import CityAPI from 'api/city';
import AirportAPI from 'api/airport';
import {Page} from 'router/page';
import {foldWithSearchState} from './utils';
import {loadable} from 'router/routes';

const SearchAirport = loadable(() => import('search/airport/SearchAirport'));

SearchAirport.getInitialState = async ({state, params, query}) => {
    const citySlug = params.city;
    const {data: city} = await CityAPI.get(citySlug);
    const iata = params.iata;
    const {data: destination} = await AirportAPI.getBySlug(iata);

    const {
        data: {timezone},
    } = city;

    const {
        data: {latitude, longitude},
    } = destination;

    return foldWithSearchState({
        state: {...state, city, destination},
        type: Page.AIRPORT,
        latitude,
        longitude,
        timezone,
        query,
    });
};

export default SearchAirport;
